import { render, staticRenderFns } from "./rich-text-tool.vue?vue&type=template&id=c252096e"
import script from "./rich-text-tool.vue?vue&type=script&lang=js"
export * from "./rich-text-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports